import { api } from "./client";
import type { Paginated, ReturnRequest } from "./types";

export interface ReturnReviewPayload {
  decision: "approve" | "reject";
  rejection_reason?: string;
  override_credit?: boolean;
}

export const returnsApi = {
  list: (params: Record<string, unknown> = {}) =>
    api.get<Paginated<ReturnRequest>>("/returns/", { params }).then((r) => r.data),
  get: (id: string) =>
    api.get<ReturnRequest>(`/returns/${id}/`).then((r) => r.data),
  review: (id: string, payload: ReturnReviewPayload) =>
    api.patch<ReturnRequest>(`/returns/${id}/review/`, payload).then((r) => r.data),
};
